import { environment } from '@environments/environment';

const baseUri = `${environment.apiUri}/energy`;
export const dnbMatchesUri = `${baseUri}/dnb-matches`;
export const eanByAddressUri = `${environment.apiUri}/elegant/ean`;
